import React from 'react';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { theme } from './theme';

type Props = {
  children: React.ReactNode;
};

/**
 * ThemeProvider Component
 *
 * Wraps the application with the TreePlotter design system theme.
 * Includes StyledEngineProvider for CSS injection order and CssBaseline for consistent baseline styles.
 *
 * @example
 * ```tsx
 * import { ThemeProvider } from '@planitgeo/treeplotter-ui-library';
 *
 * function App() {
 *   return (
 *     <ThemeProvider>
 *       <YourApp />
 *     </ThemeProvider>
 *   );
 * }
 * ```
 */
export function ThemeProvider({ children }: Props) {
  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
